import React from 'react';

import { SOCIAL_MEDIA_LINKS } from 'constants/common';

export default function LiRedirectionPage() {
  React.useEffect(() => {
    window.location.href = SOCIAL_MEDIA_LINKS[2].externalUrl as string;
  }, []);

  return <div>Redirecting...</div>;
}
